// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1t3b1wug >div{flex-basis:auto}\n._4cvr1h6o{align-items:center}\n._4t3i1w81{height:150px}\n._nphsidpf >div{flex-grow:0}\n._t1edidpf >div{flex-shrink:0}", ""]);
// Exports
module.exports = exports;
